import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=201add3d"
import script from "./LogList.vue?vue&type=script&lang=js"
export * from "./LogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports